<template>
    <div class="app-container">
        <el-row>
            <el-col :span="12">
                <v-chart ref="pillarChart" style="width: 100%;height:calc(50vh - 200px);min-height: 273px;" :options="alarmPillarOptions" v-loading="alarmPillarOptionsLoading"
                         :auto-resize="true"></v-chart>
            </el-col>
            <el-col :span="12">
                <v-chart ref="pieChart" style="width: 100%;height:calc(50vh - 200px);min-height: 273px;" :options="alarmPieOptions" v-loading="alarmPieOptionsLoading"
                         :auto-resize="true"></v-chart>
            </el-col>
        </el-row>
        <el-container>
            <el-header :style="{width:'100%',height:'100%'}">
                <el-form :inline="true" class="demo-form-inline" style="margin-top: 7px;">
                    <el-row>
                        <el-form-item>
                            <el-col :span="11">
                                <el-form-item>
                                    <el-date-picker
                                        @change="startPicker"
                                        v-model="listQuery.startTime"
                                        :style="{width:'180px'}"
                                        :placeholder="$t('commons.startTime')"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col class="line" :span="1" style="text-align: center;">-</el-col>
                            <el-col :span="11">
                                <el-form-item>
                                    <el-date-picker
                                        @change="endPicker"
                                        v-model="listQuery.endTime"
                                        :style="{width:'180px'}"
                                        :placeholder="$t('commons.endTime')"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-col :span="24">
                                <tree-select
                                        :style="{width:'180px'}"
                                        v-model="listQuery.categoryId"
                                        @select="getHistoryAlarmData"
                                        :multiple="false"
                                        :show-count="true"
                                        :placeholder="$t('base.category.system')"
                                        :options="categoryList" />
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="listQuery.msgText" clearable @clear="clearEmpty('msgText')" :style="{width:'100%'}" @change="getHistoryAlarmData" :placeholder="$t('alarm.comment')">
                                <el-option :value="'High'" :label="$t('alarm.tooHigh')"></el-option>
                                <el-option :value="'Low'" :label="$t('alarm.tooLow')"></el-option>
                                <el-option :value="'Alarm'" :label="$t('alarm.info')"></el-option>
                                <el-option :value="'Offline'" :label="$t('alarm.offline')"></el-option>
                                <el-option :value="'Fault'" :label="$t('alarm.fault')"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item >
                            <el-select v-model="listQuery.confirmFlag" clearable @clear="clearEmpty('confirmFlag')" :style="{width:'100%'}" @change="getHistoryAlarmData" :placeholder="$t('alarm.handlerState')">
                                <el-option :value="0" :label="$t('alarm.untreated')"></el-option>
                                <el-option :value="1" :label="$t('alarm.faultConfirm')"></el-option>
                                <el-option :value="2" :label="$t('alarm.misreportConfirm')"></el-option>
                                <el-option :value="3" :label="$t('alarm.fireConfirm')"></el-option>
                                <el-option :value="4" :label="$t('alarm.equipmentIsolation')"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item >
                            <el-select v-model="listQuery.alarmType" clearable @clear="clearEmpty('alarmType')" :style="{width:'100%'}" @change="getHistoryAlarmData" :placeholder="$t('alarm.alarmType')">
                                <el-option :value="1" :label="$t('alarm.runningAlarm')"></el-option>
                                <el-option :value="2" :label="$t('alarm.faultAlarm')"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="listQuery.level" clearable @clear="clearEmpty('level')" :style="{width:'100%'}" @change="getHistoryAlarmData" :placeholder="$t('base.monitor.alarmLevel')">
                                <el-option :value="3" :label="$t('base.monitor.serious')"></el-option>
                                <el-option :value="2" :label="$t('base.monitor.commonly')"></el-option>
                                <el-option :value="1" :label="$t('base.monitor.prompt')"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="listQuery.projectId" clearable @clear="clearEmpty('projectId')" :style="{width:'100%'}" @change="getHistoryAlarmData" :placeholder="$t('base.project.name')">
                                <el-option
                                        v-for="item in projectList"
                                        :label="item.projectName"
                                        :value="item.projectId"
                                        :key="item.projectId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="listQuery.deviceLevel" clearable @clear="clearEmpty('deviceLevel')" :style="{width:'100%'}" @change="getHistoryAlarmData" :placeholder="$t('base.device.level')">
                                <el-option :value="1" :label="$t('commons.one_level')"></el-option>
                                <el-option :value="2" :label="$t('commons.two_level')"></el-option>
                                <el-option :value="3" :label="$t('commons.three_level')"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="listQuery.deviceName" maxlength="25" @keyup.enter.native="getHistoryAlarmData" :placeholder="$t('base.device.name')" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" :loading="listLoading" @click="getHistoryAlarmData">{{$t('commons.search')}}</el-button>
                            <el-button type="primary" icon="el-icon-download" plain @click="exportAlarmData">{{$t('commons.export')}}</el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
            </el-header>
            <el-main :style="{width:'100%'}">
                <el-table
                        v-loading="listLoading"
                        :data="alarmList"
                        element-loading-text="loading"
                        border
                        fit
                        highlight-current-row
                        stripe>
                    <el-table-column :label="$t('base.project.name')" width="150px">
                        <template slot-scope="scope">
                            <span>{{ scope.row.projectName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.category.system')" width="150px">
                        <template slot-scope="scope">
                            <span>{{ scope.row.categoryName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.device.name')" width="150px">
                        <template slot-scope="scope">
                            <span>{{ scope.row.deviceName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.device.position')" width="150px">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.descName" placement="top">
                                <span>{{ scope.row.descName }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.device.level')" width="150px">
                        <template slot-scope="scope">
                            <span>
                                <template v-if="scope.row.deviceLevel == 1">
                                    {{$t('commons.one_level')}}
                                </template>
                                <template v-if="scope.row.deviceLevel == 2">
                                    {{$t('commons.two_level')}}
                                </template>
                                <template v-if="scope.row.deviceLevel == 3">
                                    {{$t('commons.three_level')}}
                                </template>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('alarm.alarmType')" width="155px">
                        <template slot-scope="scope">
                                <span>
                                    <template v-if="scope.row.alarmType == 1">
                                        {{$t('alarm.runningAlarm')}}
                                    </template>
                                    <template v-else-if="scope.row.alarmType == 2">
                                        {{$t('alarm.faultAlarm')}}
                                    </template>
                                </span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.monitor.alarmLevel')">
                        <template slot-scope="scope">
                            <span>
                                <template v-if="scope.row.level == 1">
                                    {{$t('base.monitor.prompt')}}
                                </template>
                                <template v-else-if="scope.row.level == 2">
                                    {{$t('base.monitor.commonly')}}
                                </template>
                                <template v-else-if="scope.row.level == 3">
                                    {{$t('base.monitor.serious')}}
                                </template>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('alarm.comment')">
                        <template slot-scope="scope">
                            <span>{{ scope.row.msgText }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('commons.status')">
                        <template slot-scope="scope">
                            <span>
                                <template v-if="scope.row.normalTimestamp != null">
                                    {{$t('commons.resume')}}
                                </template>
                                <template v-else-if="scope.row.msgText == 'Offline'">
                                    {{$t('alarm.offline')}}
                                </template>
                                <template v-else-if="scope.row.msgText == 'Fault'">
                                    {{$t('alarm.fault')}}
                                </template>
                                <template v-else-if="scope.row.msgText == 'High'">
                                    {{$t('alarm.tooHigh')}}
                                </template>
                                <template v-else-if="scope.row.msgText == 'Low'">
                                    {{$t('alarm.tooLow')}}
                                </template>
                                <template v-else>
                                    {{$t('alarm.info')}}
                                </template>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('alarm.time')" width="155px">
                        <template slot-scope="scope">
                                <span>
                                    {{ scope.row.timestamp | dateFormat('YYYY-MM-DD HH:mm:ss')}}
                                </span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('alarm.normalTime')" width="155px">
                        <template slot-scope="scope">
                                <span>
                                    {{ scope.row.normalTimestamp | dateFormat('YYYY-MM-DD HH:mm:ss')}}
                                </span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('alarm.handlerTime')" width="155px">
                        <template slot-scope="scope">
                                <span>
                                    {{ scope.row.handlerTime | dateFormat('YYYY-MM-DD HH:mm:ss')}}
                                </span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.dept.handlePerson')" width="155px">
                        <template slot-scope="scope">
                                <span>
                                    {{ scope.row.handlerPersonName}}
                                </span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('alarm.handlerState')">
                        <template slot-scope="scope">
                            <span>
                                <template v-if="scope.row.confirmFlag == 0">
                                    {{$t('alarm.untreated')}}
                                </template>
                                <template v-else-if="scope.row.confirmFlag == 1">
                                    {{$t('alarm.faultConfirm')}}
                                </template>
                                <template v-else-if="scope.row.confirmFlag == 2">
                                    {{$t('alarm.misreportConfirm')}}
                                </template>
                                <template v-else-if="scope.row.confirmFlag == 3">
                                    {{$t('alarm.fireConfirm')}}
                                </template>
                                <template v-else-if="scope.row.confirmFlag == 4">
                                    {{$t('alarm.equipmentIsolation')}}
                                </template>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('commons.remark')">
                        <template slot-scope="scope">
                                <span>
                                    {{ scope.row.alarmComment }}
                                </span>
                        </template>
                    </el-table-column>
                    <template v-if="this.$ioriPermission('iot$Service$tenantIoTAlarm$alramConfirm')">
                        <el-table-column :label="$t('commons.actions')">
                            <template slot-scope="scope">
                                <template v-if="scope.row.confirmFlag == 0">
                                    <el-button size="mini" type="primary" @click="confirmAlarm(scope.row)">{{$t('alarm.confirm')}}</el-button>
                                </template>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.current"
                            :limit.sync="listQuery.rowCount"
                            @pagination="getAlarmPage"/>
            </el-main>
        </el-container>

        <!--确认告警弹窗-->
        <confirm-alarm :alarmConfirmInfo="alarmConfirmInfo" :isShowIsolate="false" :isHistoryConfirm="true" :alarmConfirmDialog.sync="alarmConfirmDialog" :confirmAlarmEvent="confirmAlarmEvent"/>
    </div>
</template>

<script>
    // 导入主题，引用时在v-chart中增加theme="macarons"
    import 'echarts/theme/macarons'
    import TreeSelect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        getCategoryList,
        getHistoryAlarmPage,
        getAlarmTrend,
        alarmLevelCount,
        exportAlarm
    } from '@/api/business/iot/alarm/alarm'
    import {listToTree} from '@/utils/tree'
    import Pagination from '@/components/Pagination'
    import moment from 'moment'
    import ConfirmAlarm from '@/views/business/iot/alarm/confirmAlarm'
    import store from '@/store/index'
    import{
        getProjectList
    }from '@/api/business/base/tenant/project'

    export default {
        name: "HistoryAlarm",
        components:{
            TreeSelect,
            Pagination,
            ConfirmAlarm
        },
        data() {
            return {
                //告警确认窗口是否显示
                alarmConfirmDialog:false,
                categoryList:[],
                alarmPillarOptions:null,
                alarmPillarOptionsLoading:false,
                alarmPieOptions:null,
                alarmPieOptionsLoading:false,
                alarmList:[],
                projectList:[],
                listLoading: false,
                total:0,
                listQuery:{
                    current:1,
                    rowCount:10,
                    startTime:new Date(moment().subtract(7, 'days').format('YYYY-MM-DD')).getTime(),
                    endTime:null,
                    categoryId:null,
                    msgText:null,
                    confirmFlag:null,
                    deviceName:null,
                    level:null,
                    alarmType:null,
                    projectId:null,
                    deviceLevel:null
                },
                alarmConfirmInfo:null,
            }
        },
        created(){
            this.getCategoryList();
            this.getProjectList();
            this.getHistoryAlarmData();
        },
        methods:{
            getProjectList(){
                getProjectList().then(res=>{
                    this.projectList = res;
                })
            },
            getHistoryAlarmData(){
                this.InitAlarmPillarChart();
                this.InitAlarmPieChart();
                this.listQuery.current = 1;
                this.getAlarmPage();
            },
            //加载系统分类树
            getCategoryList(){
                getCategoryList().then(response =>{
                    let data = listToTree(response,"categoryId","parentId");
                    this.recursiveCategory(data)
                });
            },
            //递归位置列表修改属性及数据结构
            recursiveCategory(row){
                let data = row.map(v => {
                    v.label = v.categoryName;
                    v.id = v.categoryId;
                    if(v.children != undefined){
                        this.recursiveCategory(v.children);
                    }
                    return v
                })
                this.categoryList = data;
            },
            InitAlarmPillarChart(){
                this.alarmPillarOptionsLoading = true;
                getAlarmTrend(this.listQuery).then(data =>{
                    this.alarmPillarOptions = this.getAlarmPillarOptions(data);
                }).finally(() => {
                    this.alarmPillarOptionsLoading = false;
                })
            },
            InitAlarmPieChart(){
                this.alarmPieOptionsLoading = true;
                alarmLevelCount(this.listQuery).then(data =>{
                    this.alarmPieOptions = this.getAlarmPieOptions(data);
                }).finally(() => {
                    this.alarmPieOptionsLoading = false;
                })
            },
            getAlarmPillarOptions(data){
              return  {
                    title: {
                        text: this.$t('alarm.trend'),
                        textStyle: {
                            color: "rgb(153, 153, 153)",
                            fontSize: 16,
                            fontWeight: 'bold'
                        },
                        x:'left'
                    },
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            },
                            lineStyle: {
                                color: '#4A92FF',
                                opacity: 0.5,
                                width: 1
                            },
                        },
                    },
                    calculable : true,
                        dataZoom : [
                    {
                        type: 'inside',
                        realtime: true,
                        start: 0,
                        end: 100
                    }
                ],
                    legend: {
                    data:[this.$t('base.monitor.prompt'),this.$t('base.monitor.commonly'),this.$t('base.monitor.serious'),this.$t('alarm.total')]
                },
                    xAxis : [
                        {
                            type : 'category',
                            data : data.dateDay,
                            axisTick: {
                                alignWithLabel: true
                            },
                            axisLabel: {
                                textStyle: {
                                    color: "#A5A5A5",
                                    fontSize: 14,
                                },
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#EEEEEE'
                                }
                            },
                        }
                    ],
                        yAxis : [
                    {
                        type : 'value',
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#EEEEEE'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: "#A5A5A5",
                                fontSize: 14,
                            },
                        },
                        axisLine: {
                            show: false
                        },
                    },
                    {
                        type : 'value',
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#EEEEEE'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: "#A5A5A5",
                                fontSize: 14,
                            },
                        },
                        axisLine: {
                            show: false
                        },
                    }
                ],
                    series : [
                    {
                        name:this.$t('base.monitor.prompt'),
                        type:'bar',
                        data:data.levelOne,
                        itemStyle:{
                            normal:{
                                color:'#03A9F4'
                            }
                        },
                    },
                    {
                        name:this.$t('base.monitor.commonly'),
                        type:'bar',
                        data:data.levelTwo,
                        itemStyle:{
                            normal:{
                                color:'#FF9800'
                            }
                        },
                    },
                    {
                        name:this.$t('base.monitor.serious'),
                        type:'bar',
                        data:data.levelThree,
                        itemStyle:{
                            normal:{
                                color:'#f50000'
                            }
                        },
                    },
                    {
                        name:this.$t('alarm.total'),
                        smooth:true,
                        type:'line',
                        yAxisIndex: 1,
                        data:data.levelSum,
                        itemStyle:{
                            normal:{
                                color:'#20ebb6'
                            }
                        },
                    }
                ]
                };
            },
            getAlarmPieOptions(data){
                return {
                    title : [{
                        text: this.$t('alarm.statistics'),
                        textStyle: {
                            color: "rgb(153, 153, 153)",
                            fontSize: 16,
                            fontWeight: 'bold'
                        },
                        x:'left'
                    },
                        {
                            text: data[0]+data[1]+data[2],
                            //textAlign: 'center',
                            left: 'center',
                            top: 'center',
                            textStyle: {
                                fontSize: 50,
                                color: 'rgba(160, 184, 100, 0.7)'
                            }
                        }
                    ],
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'right',
                        data:  [this.$t('base.monitor.prompt'),this.$t('base.monitor.commonly'),this.$t('base.monitor.serious')]
                    },
                    series : [
                        {
                            name:this.$t('alarm.statisticsNum'),
                            type: 'pie',
                            radius : ['45%', '60%'],
                            data: [
                                {value:data[0], name:this.$t('base.monitor.prompt')},
                                {value:data[1], name:this.$t('base.monitor.commonly')},
                                {value:data[2], name:this.$t('base.monitor.serious')}
                            ],

                            itemStyle : {
                                normal : {
                                    label : {
                                        show :true
                                    },
                                    labelLine : {
                                        show :true
                                    },
                                    color: function(params) {
                                        // build a color map as your need.
                                        let colorList = [
                                            '#03A9F4','#FF9800','#f50000'
                                        ];
                                        return colorList[params.dataIndex]
                                    }
                                }

                            }
                        }
                    ]
                };
            },
            startPicker(time){
                this.listQuery.startTime = time.getTime()
                this.getHistoryAlarmData();
            },
            endPicker(time){
                this.listQuery.endTime = time.getTime()
                this.getHistoryAlarmData();
            },
            getAlarmPage(){
                this.listLoading = true;
                getHistoryAlarmPage(this.listQuery).then(data =>{
                    this.total = data.total;
                    this.alarmList = data.rows;
                    this.listLoading = false;
                })
            },
            //告警确认后回调
            confirmAlarmEvent(){
                this.getAlarmPage();
            },
            confirmAlarm(data){
                data.timestamp = moment(new Date(data.timestamp).getTime()).format('YYYY-MM-DD HH:mm:ss');
                this.alarmConfirmInfo = Object.assign({}, data);
                this.alarmConfirmDialog = true;
            },
            closeAlarmDialog(){
                this.alarmConfirmDialog = false;
            },
            exportAlarmData(){
                exportAlarm(this.listQuery).then((msg)=>{
                    this.$message({type: 'success', message: this.$t('message.operationSuccess')});
                    let exportObj = {
                        taskId : msg,
                        taskName : "Alarm",
                        taskStatus : 0,
                        rootPath : 'nanhaiPath'
                    };
                    //将导出任务丢入导出任务列表中
                    store.dispatch('PushExportTaskList',exportObj);
                })
            },
            clearEmpty(field) {
                this.listQuery[field] = null
            }
        }
    }
</script>

<style scoped>
    .el-header, .el-footer {
        padding: 0px;
    }

    .el-aside {
        padding: 0px;
    }

    .el-main {
        padding: 0px;
    }
</style>
